// MasterDataLayout.tsx
import { useAuth } from "@/hooks/useAuth";
import { MasterDataProvider } from "@/hooks/useMasterData";
import { useLocation } from "react-router";
import { getMasterDataMap } from "@/config/routes";

const masterDataByPath = getMasterDataMap();

export const MasterDataLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const requiredServices = masterDataByPath[location.pathname] ?? [];
  const { auth } = useAuth();

  return (
    <MasterDataProvider
      requiredServices={requiredServices}
      serviceConfig={{
        aprobadores: { filters: { correosAExcluir: [auth?.user?.email!] } },
      }}
    >
      {children}
    </MasterDataProvider>
  );
};
